import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { FileExport } from 'app/models/import-gift.model';
import { Campaign2Service } from 'app/services/campaign-2.0/campaign2.service';
import * as mammoth from 'mammoth';
import { SelectItem } from 'primeng/components/common/api';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/forkJoin';
import { tap } from 'rxjs/operators';
import * as XLSX from 'xlsx';


type AOA = FileExport[];
@Component({
  selector: 'app-coupon-parameters-setup',
  templateUrl: './coupon-parameters-setup.component.html',
  styleUrls: ['./coupon-parameters-setup.component.scss', '../coupon-setup.scss']
})
export class CouponParametersSetupComponent implements OnInit {
  acmListFilter: SelectItem[] = [];
  messageInstanceId: string;
  messages: SelectItem[] = [];
  MessageInstanceDtoSchema: any;
  BasketDtoSchema: any;
  messageInstanceForm: FormGroup;
  fields: any;  // Campi da visualizzare
  invalidSubmit = false;
  promoTypes: SelectItem[];
  exclusionTypes: SelectItem[] = [{ label: '', value: null }];
  constraints: SelectItem[] = [{ label: '', value: null }];
  selectedMessageId: number;
  itemBasketFile: File;
  itemBasketData: AOA;
  textFileData: string = '';
  basketId: number;
  stateAction: string;
  campaignId: number;
  campaignActionid: number;
  actualStep: string = "parameter";
  couponUseNumber: number = 1;
  couponUseTypes: SelectItem[];
  couponUseType: string;
  update: boolean;
  basketList: SelectItem[];
  actionTypeCode: string;
  departmentList: any[] = [];
  basketDetailList: any[] = [];//lista di appoggio necessaria per sdoppiare il comportamento, in caso di modifica, tra create e update di nuovi/vecchi reparti
  selectedDepartment: any[];
  app: boolean;
  messageInstanceName: string;
  messageInstanceDescription: string;
  departmentsLoaded: boolean;
  acmSave: boolean = false;
  targetLoyaltyClass: string;
  thresholdTypeList: any[];
  selectedThresholdType: any;
  messageInstanceRuleId: number;
  messageInstanceRuleTypeId: number;
  deployFlag: string;

  constructor(
    private campaignService: Campaign2Service,
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private translateService: TranslateService,
    private router: Router
  ) { }

  ngOnInit() {
    this.messageInstanceId = this.activatedRoute.snapshot.params['messageInstanceId'];
    this.actionTypeCode = this.activatedRoute.snapshot.paramMap.get('actionTypeCode') || null;
    Observable.forkJoin(
      this.campaignService.getMessageInstanceData(this.messageInstanceId).pipe(tap(res => {
        this.stateAction = res[0].campaign_action_status_id;
        this.campaignId = res[0].campaign_id;
        this.campaignActionid = res[0].campaign_action_id;
        this.messageInstanceName = res[0].name;
        this.messageInstanceDescription = res[0].description;
        this.deployFlag = res[0].flg_dpl;
      })),
      this.campaignService.getMultipleCouponRuleType().pipe(tap(res => this.messageInstanceRuleTypeId = res[0].id)),
      ...['MessageInstance', 'Basket'].map(schema =>
        this.campaignService.getDtoSchemas(schema).pipe(tap(res => this[schema + 'DtoSchema'] = res))
      ),
      this.campaignService.getCampaignMessage(this.actionTypeCode === 'MSG' ? 'message' : 'coupon').pipe(tap(res => {
        res.forEach(message => this.messages.push({
          label: message.description,
          value: {
            id: message.id,
            messageTypeId: message.message_type_id,
            target_loyalty_class: message.target_loyalty_class,
            promo_emission: message.promo_emission
          }
        }));
      })),
      this.campaignService.getConstraints('E').pipe(tap(res => {
        res.forEach(et => this.exclusionTypes.push({ label: et.name, value: et.id }));
      })),
      this.campaignService.getConstraints('C').pipe(tap(res => {
        res.forEach(constraint => this.constraints.push({ label: constraint.name, value: constraint.id }));
      }))
    ).subscribe(([messageInstanceData]) => {
      if (messageInstanceData && messageInstanceData.length > 0) {
        this.setFormData(messageInstanceData[0]);
      } else {
        this.setFormData();
      }
      this.getCampaignAcmList();
      this.loadMessageInstanceRule();
    });
  }

  setFormData(data?: any) {
    this.couponUseTypes = [
      { label: '', value: null },
      { label: this.translateService.instant('campaign.singleUse'), value: 'S' },
      { label: this.translateService.instant('campaign.multiUse'), value: 'M' }
    ];
    this.thresholdTypeList = [
      { label: null, value: null },
      { label: this.translateService.instant('campaign.thresholdValue'), value: 'EV' },
      { label: this.translateService.instant('campaign.thresholdQuantity'), value: 'QT' }
    ];
    if (data) {
      this.setForm(data);
      this.getFields({ id: data.message_id, messageTypeId: data.message_type_id, target_loyalty_class: data.target_loyalty_class }, data);
      this.couponUseNumber = data.coupon_use_number;
      this.couponUseType = data.coupon_use_type;

      this.basketId = data.basket_id;

      if (this.couponUseNumber != null) {
        this.update = true;
      }

      this.loadProductDepartment();

      this.campaignService.getConstraintsData(this.messageInstanceId).subscribe(res => {
        if (res && res.length > 0) {
          res.forEach(constraint => {
            if (constraint.constraint_type === 'E') {
              this.messageInstanceForm.get('exclusion_type').setValue(constraint.campaign_constraint_id);
            } else if (constraint.constraint_type === 'C') {
              this.messageInstanceForm.get('other_constraints').setValue(constraint.campaign_constraint_id);
            }
          });
        }
      });
    } else {
      this.setForm();
    }
  }

  setForm(data?: any) {
    if (data) {
      this.messageInstanceForm = this.fb.group({
        // MessageInstanceDto
        promo_type_id: [data.promo_type_id],
        coupon_amt: [data.coupon_amt / 100],
        flg_dynamicCoupon: data.flg_couponing_method === 'D' ? true : false, // Custom
        total_coupon_number: [data.total_coupon_number != 9999999999 ? data.total_coupon_number : null],
        threshold_value: [data.threshold_value / 100],
        flg_open_coupon: +data.flg_open_coupon,
        flg_couponType: data.coupon_type === 'R' ? true : false,
        // BasketDto
        description: [''],
        basket: '',
        // Custom
        exclusion_type: [''],
        other_constraints: [''],
        // MessageInstanceRuleDto
        threshold_rule_value: [null],
        repetition_threshold: [null],
        threshold_type: [null],
        max_coupon_number: [null],
        flg_rolling: data.flg_rolling === '1' ? true : false
      });
    } else {
      this.messageInstanceForm = this.fb.group({
        // MessageInstanceDto
        promo_type_id: [null],
        coupon_amt: [null],
        flg_dynamicCoupon: [''], // Custom
        total_coupon_number: [null],
        threshold_value: [null],
        flg_open_coupon: [''],
        flg_couponType: false,
        // BasketDto
        description: [''],
        basket: '',
        // Custom
        exclusion_type: [''],
        other_constraints: [''],
        // MessageInstanceRuleDto
        threshold_rule_value: [null],
        repetition_threshold: [null],
        threshold_type: [null],
        max_coupon_number: [null],
        flg_rolling: false
      });
    }
  }

  getSelectedMessage() {
    return this.messages.filter(ms => ms.value.id === this.selectedMessageId)[0];
  }

  getSelectedMessageDescription() {
    return this.getSelectedMessage()['label'];
  }

  getFields(message: any, data?: any) {
    this.selectedMessageId = message.id;
    this.targetLoyaltyClass = message.target_loyalty_class;
    // get campi da visualizzare
    this.campaignService.getCouponParamSetupFields(message.id, this.actionTypeCode === 'MSG' ? "message" : "coupon").subscribe(res => {
      if (res && res.length > 0) {
        this.fields = res[0].form_def.map;
        this.getPromotypes(message.messageTypeId).then(() => {
          if (data) {
            this.messageInstanceForm.get('promo_type_id').setValue(data.promo_type_id);
            if (this.fields.coupon_unit_measure) {
              this.messageInstanceForm.get('threshold_value').setValue(data.threshold_value / 100);
            }
          } else {
            this.clearValueFormJson();
          }
          if (this.targetLoyaltyClass === 'NOLOY' || this.targetLoyaltyClass === 'ALL' || this.fields.flag_rolling || this.fields.check_repeatable) {
            if (data) {
              this.messageInstanceForm.get('flg_dynamicCoupon').setValue(data.flg_couponing_method === 'D' ? true : false);
            } else {
              this.messageInstanceForm.get('flg_dynamicCoupon').setValue(true);
            }
          }
          if (this.fields.check_repeatable && data == null) {
            this.messageInstanceForm.get('flg_couponType').setValue(true);
          }
          if (this.fields.flag_rolling && data == null) {
            this.messageInstanceForm.get('flg_rolling').setValue(true);
          }
        });
      } else {
        this.fields = null;
      }
    });
  }

  clearValueFormJson() {
    this.messageInstanceForm.reset();
    this.couponUseNumber = this.fields.check_repeatable ? 1 : null;
    this.selectedDepartment = null;
    this.couponUseType = null;
  }

  getPromotypes(messageTypeId: number) {
    return new Promise((resolve, reject) => {
      this.promoTypes = [];
      this.campaignService.getPromoTypes(messageTypeId).subscribe(
        res => {
          res.forEach(pt => this.promoTypes.push({ label: pt.name, value: pt.id }));
          if (this.promoTypes.length === 1) {
            {
              this.messageInstanceForm.get('promo_type_id').setValue(this.promoTypes[0].value);
            }
          }
          resolve(null);
        },
        err => reject(err)
      );
    });
  }

  getBasketList(basketDesc?: string) {
    this.basketList = [{ label: '', value: null }];
    this.campaignService.getBasketList(basketDesc).subscribe(res => {
      res.forEach(basket => this.basketList.push({ label: basket.description, value: basket.id }));
    });
  }

  onItemBasketFileUpload(event) {
    if (event.files.length !== 1) {
      throw new Error(this.translateService.instant('common.multipleUploadError'));
    }
    this.itemBasketFile = event.files[0];
  }

  importItemBasketFile() {
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary', cellDates: true });
      /* grab first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];
      /* save data */
      this.itemBasketData = <AOA>(XLSX.utils.sheet_to_json(ws, { blankrows: true, defval: null }));
      const data = {
        description: this.messageInstanceForm.get('description').value || this.basketId,
        basket_details: this.itemBasketData
      };
      this.campaignService.saveNewBasket(this.messageInstanceId, data).subscribe();
    };
    if (this.itemBasketFile != null) {
      reader.readAsBinaryString(this.itemBasketFile);
    }
    this.itemBasketFile = null;
  }

  onItemTextFileUpload(event: any) {
    if (event.files.length !== 1) {
      throw new Error(this.translateService.instant('common.multipleUploadError'));
    }
    const file = event.files[0];
    const fileExtension = file.name.split('.').pop();
    const reader = new FileReader();
    if (fileExtension === 'txt') {
      reader.onload = (event: any) => {
        this.textFileData = event.target.result;
      }
      reader.readAsText(file);
    } else if (fileExtension === 'docx') {
      reader.onload = this.handleReaderLoaded.bind(this);
      reader.readAsArrayBuffer(file);
    }
  }

  handleReaderLoaded(e) {
    mammoth.extractRawText({ arrayBuffer: e.target.result }).then(res => this.textFileData = res.value);
  }

  save() {
    if (!this.acmSave) {
      if (!this.messageInstanceForm.valid) {
        this.invalidSubmit = true;
        return;
      }
      if (!this.couponUseNumber && this.actionTypeCode !== 'MSG') {
        this.invalidSubmit = true;
        return;
      }
    }

    this.invalidSubmit = false;

    let data = {
      id: +this.messageInstanceId,
      promo_type_id: this.messageInstanceForm.get('promo_type_id').value,
      coupon_amt: this.messageInstanceForm.get('coupon_amt').value * 100,
      threshold_value: this.messageInstanceForm.get('threshold_value').value * 100,
      flg_open_coupon: this.messageInstanceForm.get('flg_open_coupon').value ? 1 : 0,
      coupon_use_number: this.actionTypeCode === 'MSG' ? 1 : this.couponUseNumber,
      message_id: this.selectedMessageId,
      flg_couponing_method: this.messageInstanceForm.get('flg_dynamicCoupon').value ? 'D' : 'S',
      total_coupon_number: this.messageInstanceForm.get('flg_dynamicCoupon').value ? this.messageInstanceForm.get('total_coupon_number').value : null,
      campaign_constraint_id: [this.messageInstanceForm.get('exclusion_type').value || null, this.messageInstanceForm.get('other_constraints').value || null],
      target_loyalty_class: this.getSelectedMessage()['value']['target_loyalty_class'],
      promo_emission: this.getSelectedMessage()['value']['promo_emission'],
      basket_id: this.basketId,
      flg_rolling: this.messageInstanceForm.get('flg_rolling').value == true ? '1' : '0',
      coupon_type: this.messageInstanceForm.get('flg_couponType').value ? 'R' : 'S',
    }
    if (this.couponUseType) {
      Object.assign(data, { coupon_use_type: this.couponUseType });
    } else {
      Object.assign(data, { coupon_use_type: 'S' });
    }
    const selectedBasket = this.messageInstanceForm.get('basket').value;
    let basketDetail = {};

    /* if (this.fields.department && this.departmentList && this.departmentList.length > 0 && (!this.selectedDepartment || this.selectedDepartment.length === 0)) {
       this.invalidSubmit = true;
       return;
     }*/

    if (this.messageInstanceForm.get('flg_couponType').value) {
      if (!this.messageInstanceForm.get('threshold_rule_value').value || !this.messageInstanceForm.get('threshold_type').value ||
        !this.messageInstanceForm.get('repetition_threshold').value || !this.messageInstanceForm.get('max_coupon_number').value) {
        this.invalidSubmit = true;
        return
      }
      this.invalidSubmit = false;
      let messageInstanceRuleData = {
        message_instance_id: this.messageInstanceId,
        rule_type_id: this.messageInstanceRuleTypeId,
        rule_scope: 'emission',
        threshold_value: this.messageInstanceForm.get('threshold_rule_value').value * 100,
        threshold_type: this.messageInstanceForm.get('threshold_type').value,
        repetition_threshold: this.messageInstanceForm.get('repetition_threshold').value,
        max_coupon_number: this.messageInstanceForm.get('max_coupon_number').value
      }
      if (this.update && this.messageInstanceRuleId) {
        this.campaignService.updateMessageInstanceRule(this.messageInstanceRuleId, messageInstanceRuleData).subscribe();
      }
      else {
        this.campaignService.createMessageInstanceRule(messageInstanceRuleData).subscribe();
      }
    }
    else if (this.update && this.messageInstanceForm.get('threshold_rule_value').value) {
      console.log("pipo");
      this.invalidSubmit = false;
      let messageInstanceRuleData = {
        message_instance_id: this.messageInstanceId,
        rule_type_id: this.messageInstanceRuleTypeId,
        rule_scope: 'emission',
        threshold_value: this.messageInstanceForm.get('threshold_rule_value').value * 100,
        threshold_type: this.messageInstanceForm.get('threshold_type').value,
        repetition_threshold: this.messageInstanceForm.get('repetition_threshold').value,
        max_coupon_number: this.messageInstanceForm.get('max_coupon_number').value
      }
      if (this.messageInstanceRuleId) {
        this.campaignService.updateMessageInstanceRule(this.messageInstanceRuleId, messageInstanceRuleData).subscribe();
      } else {
        this.campaignService.createMessageInstanceRule(messageInstanceRuleData).subscribe();
      }

    } else if (this.messageInstanceForm.get('threshold_rule_value').value) {
      this.campaignService.deleteMessageInstanceRuleAndDetail(this.messageInstanceRuleId).subscribe();
    }
    if (selectedBasket) {
      Object.assign(data, { basket_id: selectedBasket.value });

      if ((this.fields.department && this.fields.department.length > 0) || (this.selectedDepartment && this.selectedDepartment.length > 0)) {
        this.selectedDepartment.forEach(department => {
          basketDetail = {
            basket_id: selectedBasket.value,
            product_department_id: department.id,
            product_department_code: department.host_code,
            exclude: 0
          }
          let updateBskIndex = null;
          this.basketDetailList.forEach((bskDet, index) => {
            if (department === bskDet) {
              updateBskIndex = index;
              this.basketDetailList.splice(updateBskIndex, 1);
            }

          });

          if (updateBskIndex != undefined && updateBskIndex != null) {
            this.campaignService.updateBasketDetail(department.basket_detail_id, basketDetail).subscribe();
          } else {
            this.campaignService.createBasketDetail(basketDetail).subscribe();
          }
        })
        if (this.basketDetailList.length != 0) {
          this.basketDetailList.forEach(bskDet => {
            this.campaignService.removeBasketDetail(bskDet.basket_detail_id).subscribe();
          });
        }
      }
      this.saveParameterData(data);
    } else {
      let dataBasket = {
        name: this.messageInstanceName,
        description: `${this.messageInstanceName} created by default`
      };
      if (this.selectedDepartment != undefined && this.selectedDepartment != null && this.selectedDepartment.length > 0) {
        this.campaignService.createBasket(this.messageInstanceId, dataBasket).subscribe(res => {
          this.selectedDepartment.forEach(department => {
            basketDetail = {
              basket_id: res.id,
              product_department_id: department.id,
              product_department_code: department.host_code,
              exclude: 0
            }
            let updateBskIndex = null;
            this.basketDetailList.forEach((bskDet, index) => {
              if (department === bskDet) {
                updateBskIndex = index;
              }
            });
            if (updateBskIndex != undefined && updateBskIndex != null) {
              this.campaignService.updateBasketDetail(this.basketId, basketDetail).subscribe(res => {
                this.basketDetailList.splice(updateBskIndex, 1);
                data.basket_id = this.basketId;
              });

            } else {
              this.campaignService.createBasketDetail(basketDetail).subscribe(res => { });
            }
          })

          this.basketDetailList.forEach(bskDet => {
            this.campaignService.removeBasketDetail(bskDet.basket_detail_id).subscribe();
          });

          data.basket_id = res.id;
          this.saveParameterData(data);
        });
      }
      else {
        this.saveParameterData(data)
      }
    }

  }

  saveParameterData(data) {
    if (this.update) {
      this.campaignService.updateCouponParametersData(data, +this.messageInstanceId, this.actionTypeCode).subscribe(() => {
        if (this.itemBasketFile) {
          if (!this.messageInstanceForm.get('description').value) {
            this.invalidSubmit = true;
            return;
          }
          this.importItemBasketFile();
        }
        if (this.fields.acm_button && this.acmSave) {
          this.router.navigate([`campaign-acm/${this.messageInstanceId}`]);
        } else {
          /*this.router.navigate(['campaign-coupon-fruition-setup/' + this.messageInstanceId + '/' + this.campaignActionid, {
            actionTypeCode: 'CPN'
          }]);*/
          if (this.actionTypeCode !== 'MSG') {
            this.router.navigate(['campaign-coupon-fruition-setup/' + this.messageInstanceId + '/' + this.campaignActionid, {
              actionTypeCode: 'CPN'
            }]);
          } else {
            this.router.navigate([`campaign-coupon-layout-setup/${this.messageInstanceId}/${this.campaignActionid}`, {
              actionTypeCode: this.actionTypeCode
            }]);
          }
        }
      });
    } else {
      this.campaignService.saveCouponParametersData(data).subscribe(() => {
        if (this.itemBasketFile) {
          if (!this.messageInstanceForm.get('description').value) {
            this.invalidSubmit = true;
            return;
          }
          this.importItemBasketFile();
        }
        if (this.fields.acm_button && this.acmSave) {
          this.router.navigate([`campaign-acm/${this.messageInstanceId}`]);
        } /*else
          this.router.navigate(['campaign-coupon-fruition-setup/' + this.messageInstanceId + '/' + this.campaignActionid, {
            actionTypeCode: 'CPN'
        }]);*/
        if (this.actionTypeCode !== 'MSG') {
          this.router.navigate(['campaign-coupon-fruition-setup/' + this.messageInstanceId + '/' + this.campaignActionid, {
            actionTypeCode: 'CPN'
          }]);
        } else {
          this.router.navigate([`campaign-coupon-layout-setup/${this.messageInstanceId}/${this.campaignActionid}`, {
            actionTypeCode: this.actionTypeCode
          }]);
        }
      });
    }
  }

  goToAcm() {
    this.acmSave = true;
    this.save();
  }

  getCampaignAcmList() {
    this.campaignService.getCampaignAcmList(this.messageInstanceId).subscribe(res => {
      res.forEach(res => this.acmListFilter.push({ label: res.channel_code + ' - ' + res.acm_name, value: res.id }))
    });
  }

  loadMessageInstanceRule() {
    this.campaignService.getMessageInstanceRule(this.messageInstanceId).subscribe(res => {
      if (res.length > 0) {
        this.messageInstanceRuleId = res[0].id;
        this.messageInstanceForm.controls['threshold_rule_value'].setValue(res[0].threshold_value / 100);
        this.messageInstanceForm.controls['repetition_threshold'].setValue(res[0].repetition_threshold);
        this.messageInstanceForm.controls['threshold_type'].setValue(res[0].threshold_type);
        this.messageInstanceForm.controls['max_coupon_number'].setValue(res[0].max_coupon_number);
      }
    });
  }

  loadSelectedDepartment() {
    if (this.basketId) {
      this.campaignService.getBasketDescriptionByBasketId(this.basketId).subscribe(resBasket => {
        if (resBasket) {
          this.messageInstanceForm.get('basket').setValue({ label: resBasket.description, value: resBasket.id });
        }
        this.campaignService.getProductDepartmentByBasket(this.basketId).subscribe(resProductDepartment => {
          this.selectedDepartment = [];
          resProductDepartment.forEach(basketDetail => {
            this.departmentsLoaded = true;
            this.departmentList.push({ label: `${basketDetail.host_code} - ${basketDetail.description}`, value: basketDetail });
            this.selectedDepartment.push(basketDetail);
            this.basketDetailList.push(basketDetail);
          });
        });
      });
    }
  }

  loadProductDepartment() {
    this.loadSelectedDepartment();
    this.campaignService.getProductDepartmentList().subscribe(resProductDepartmentList => {
      if (!this.selectedDepartment) {
        this.selectedDepartment = [];
      }
      resProductDepartmentList.forEach(department => {
        this.app = false;
        this.selectedDepartment.forEach(app => {
          if (department.host_code === app.host_code && department.code === app.code
            && department.description === app.description) {
            this.app = true;
            return;
          }
        });
        if (!this.app)
          this.departmentList.push({ label: `${department.host_code} - ${department.description}`, value: department });
      })
    });
  }

  refreshMultupli() {
    if (this.messageInstanceForm.get('flg_couponType').value === true || this.messageInstanceForm.get('flg_rolling').value === true) {
      this.messageInstanceForm.get('flg_dynamicCoupon').setValue(true);
      this.couponUseNumber = 1;
    }
    if (this.messageInstanceForm.get('flg_couponType').value === false) {
      this.couponUseNumber = this.messageInstanceForm.get('flg_dynamicCoupon').value === true ? 1 : null;
      this.selectedDepartment = null;
      this.couponUseType = null;
      this.messageInstanceForm.get('threshold_rule_value').setValue(null);
      this.messageInstanceForm.get('repetition_threshold').setValue(null);
      this.messageInstanceForm.get('threshold_type').setValue(null);
      this.messageInstanceForm.get('max_coupon_number').setValue(null);
    }
  }

  refreshRolling() {
    if (this.messageInstanceForm.get('flg_couponType').value === true || this.messageInstanceForm.get('flg_rolling').value === true) {
      this.messageInstanceForm.get('flg_dynamicCoupon').setValue(true);
      this.couponUseNumber = 1;
    }
  }



  checkDisable() {
    if ((this.messageInstanceForm.get('flg_couponType').value === true || this.messageInstanceForm.get('flg_rolling').value === true || this.actionTypeCode === 'MSG') &&
      (this.targetLoyaltyClass === 'NOLOY' || this.targetLoyaltyClass === 'ALL' || this.deployFlag == 'P'))
      return true
    else
      return false
  }

  refreshDinamico() {
    if (this.messageInstanceForm.get('flg_dynamicCoupon').value === false)
      this.messageInstanceForm.get('total_coupon_number').setValue(null);
  }

}



// WEBPACK FOOTER //
// ./src/app/views/campaign-2.0/coupon-parameters-setup/coupon-parameters-setup.component.ts